import React from 'react';
import ReactDOM from 'react-dom/client';
import '../src/index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from './components/Theme';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider theme={theme}>
    <App />
    </ThemeProvider>
);

